import { error, tabaPayError } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const CancelTabapayTransfer = gql`
  mutation CancelTabapayTransfer($input: CancelTabapayTransferInput!) {
    cancelTabapayTransfer(input: $input) {
      ... on CancelTabapayTransferError {
        ...error
        __typename
      }

      ... on CancelTabapayTransferSuccess {
        success
        __typename
      }

      ... on TabaPayCustomError {
        ...tabaPayError
        __typename
      }
    }
  }
  ${error}
  ${tabaPayError}
`;

export default CancelTabapayTransfer;
